import { render, staticRenderFns } from "./LeaderboardGrid.vue?vue&type=template&id=60f9882b&scoped=true&"
import script from "./LeaderboardGrid.vue?vue&type=script&lang=js&"
export * from "./LeaderboardGrid.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardGrid.vue?vue&type=style&index=0&id=60f9882b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f9882b",
  null
  
)

export default component.exports